import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RmaCommentModel, RmaItemModel, ShippingArrivalModel } from '../models/rma.model';
import { UserService } from './user.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class RmaMasterService {

 readonly apiController = "/RmaMasters";
 BaseURI : string;

 form : FormGroup = RmaItemModel.getFormGroup();

 constructor(private http : HttpClient, private userservice : UserService) {
   console.log("constructor : RmaMasterService ");
   this.BaseURI = window.location.origin + "/api";
 }

 populateForm(item) {

  this.form.setValue(item);
 }

 getDetail(id)
 {
    return this.http.get(this.BaseURI + this.apiController + "/" + id);
 }

 getList()
 {
    return this.http.get(this.BaseURI + this.apiController);
 }

 getListbyStatus(status)
 {
    return this.http.get(this.BaseURI + this.apiController + "/GetRmaMasterByStatus?status=" + status);
 }


 getRmaItemList(id)
 {
    return this.http.get(this.BaseURI + this.apiController + "/GetRmaItemList?id=" + id);
 }

 getRmaCommentList(id, itemid = null)
 {
    if(itemid)
    {
      return this.http.get(this.BaseURI + this.apiController + "/GetRmaCommentList?id=" + id + "&itemid=" + itemid);
    }

    return this.http.get(this.BaseURI + this.apiController + "/GetRmaCommentList?id=" + id);

 }

 getRmaItemSNList(itemid)
 {
   return this.http.get(this.BaseURI + this.apiController + "/GetRmaItemSNList?itemid=" + itemid);
 }

 updateComment(item : RmaCommentModel)
 {
    return this.http.put(this.BaseURI + this.apiController + "/UpdateRmaComment?id=" + item.commentId, item);
 }

 appendComment(item : RmaCommentModel)
 {
    item.createBy = this.userservice.getUserID();
    return this.http.post(this.BaseURI + this.apiController + "/AppendRmaComment", item);
 }

 deleteComment(id)
 {
    return this.http.delete(this.BaseURI + this.apiController + "/DeleteRmaComment?id=" + id);
 }

  approveItem(item) {
      item.comment.createBy = this.userservice.getUserID();
      return this.http.post(this.BaseURI + this.apiController + "/ApproveRmaItem", item);
  }

  declineItem(item) {
    item.comment.createBy = this.userservice.getUserID();
    return this.http.post(this.BaseURI + this.apiController + "/DeclineRmaItem", item);
  }

  testItem(item) {
    item.comment.createBy = this.userservice.getUserID();
    return this.http.post(this.BaseURI + this.apiController + "/TestRmaItem", item);
  }


  closeRmaRequest(item) {
    item.closeBy = item.comment.createBy = this.userservice.getUserID();
    return this.http.post(this.BaseURI + this.apiController + "/CloseRmaRequest", item);
  }

  processRmaRequest(item) {
    item.statusBy = item.comment.createBy = this.userservice.getUserID();
    return this.http.post(this.BaseURI + this.apiController + "/ProceedRmaRequest", item);
  }

 insertData(item) {
//   return this.http.post(this.BaseURI + this.apiController, _.omit(item.rmaMaster, ["rmaId", "createTime"]));
   item.statusBy = item.createBy = this.userservice.getUserID();

   return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["rmaId", "rmaNo", "createTime", "statusTime"]));
 }

 sendRMARequestNotification(item) {
     return this.http.post(this.BaseURI + this.apiController + "/SendRMARequestNotification", item);
 }

 sendRMAApprovalNotification(item) {
  return this.http.post(this.BaseURI + this.apiController + "/SendRMAApprovalNotification", item);
}

 updateData(item) {
   return this.http.put(this.BaseURI + this.apiController + "/" + item.arrivalId, item);
 }


 deleteData(id)
 {
   return this.http.delete(this.BaseURI + this.apiController + "/" + id);

 }

 initializeFormGroup(){
  RmaItemModel.initializeFormGroup(this.form);
 }

}
